<template>
  <div class="senha-form">
    <div class="columns">
      <div class="column">
        <form @submit.prevent="atualizar" class="form-template">
          <div class="columns">
            <div class="column">
              <b-field
                :label="labelSenha"
                :type="{ 'is-danger': errors.has('password') }"
                :message="errors.first('password')"
                class="password-field"
              >
                <b-input
                  v-model.lazy="senha"
                  name="senha"
                  type="password"
                  :data-vv-as="$t('fields_validator.password')"
                  password-reveal
                  :placeholder="commonPlaceholder"
                />
              </b-field>
            </div>
            <div class="column">
              <b-field
                :label="labelNovaSenha"
                :type="{ 'is-danger': errors.has('password') }"
                :message="errors.first('password')"
                class="password-field"
              >
                <b-input
                  v-model.lazy="novaSenha"
                  name="novaSenha"
                  type="password"
                  :data-vv-as="$t('fields_validator.password')"
                  password-reveal
                  :placeholder="commonPlaceholder"
                  @input="verificadorPoliticas.validar(novaSenha)"
                />
              </b-field>
              <!-- -->
              <senha-politicas
                v-model="verificadorPoliticas.politicas"
                v-if="verificadorPoliticas !== null"
              />
              <!-- -->
              <b-field
                :label="labelConfirmaNovaSenha"
                :type="{ 'is-danger': errors.has('password') }"
                :message="errors.first('password')"
                class="password-field"
              >
                <b-input
                  v-model.lazy="confirmaNovaSenha"
                  name="confirmaNovaSenha"
                  type="password"
                  :data-vv-as="$t('fields_validator.password')"
                  password-reveal
                  :placeholder="commonPlaceholder"
                />
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4 is-offset-8">
              <div class="field">
                <button :disabled="!isReady" class="button button-primary">
                  {{ this.$t('botoes.atualizar') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <modal-template v-if="showModal" class="override-modal">
          <template #header>
            <h2>{{ modalInfo.titulo }}</h2>
          </template>
          <template #body>
            <pre class="pre-mensagens">{{ modalInfo.subtitulo }}</pre>
          </template>
          <template #footer>
            <button
              id="loginmodal"
              class="button button-primary"
              @click="modalInfo.acaoBotao"
            >
              {{ modalInfo.btnTexto }}
            </button>
          </template>
        </modal-template>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import { format, parseISO } from 'date-fns'
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { SET_PERFIS, SET_DADOS_PACIENTE } from '@/store/modules/mutation-types'
import { mapActions, mapMutations } from 'vuex'
import authService from '@/services/auth-service'
import { VerificadorSenha } from '../../mixins/verificador-senha'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import SenhaPoliticas from './Senha/SenhaPoliticas.vue'

export default {
  components: {
    ModalTemplate,
    SenhaPoliticas
  },
  data() {
    return {
      showModal: false,
      disabledButton: true,
      commonPlaceholder: this.$t('placeholders.common'),
      labelRegistro: this.$t('labels.registro'),
      labelSenha: this.$t('labels.senha_antiga'),
      labelNovaSenha: this.$t('labels.senha_nova'),
      labelConfirmaNovaSenha: this.$t('labels.senha_confirmacao'),
      mandatory: this.$t('login.mandatory'),
      senha: '',
      novaSenha: '',
      confirmaNovaSenha: '',
      verificadorPoliticas: null,
      modalInfo: {
        titulo: '',
        subtitulo: '',
        btnTexto: '',
        acaoBotao: this.toggleInfoModal
      }
    }
  },

  props: {
    paciente: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    var dataNascimento = format(
      parseISO(this.paciente.DataNascimento),
      'ddMMyyyy'
    )
    this.verificadorPoliticas = new VerificadorSenha(
      this.novaSenha,
      this.paciente.Prontuario,
      dataNascimento,
      {
        mensagens: {
          tamanhoMinimo: this.$t('validacao_senha.tamanho_minimo'),
          contem_numero: this.$t('validacao_senha.contem_numero'),
          contem_minuscula: this.$t('validacao_senha.contem_minuscula'),
          contem_maiuscula: this.$t('validacao_senha.contem_maiuscula'),
          nao_contem_sequencias: this.$t(
            'validacao_senha.nao_contem_sequencias'
          ),
          nao_contem_prontuario: this.$t(
            'validacao_senha.nao_contem_prontuario'
          ),
          nao_contem_data_nascimento: this.$t(
            'validacao_senha.nao_contem_data_nascimento'
          )
        }
      }
    )
  },

  computed: {
    isReady() {
      if (
        this.senha !== '' &&
        this.novaSenha !== '' &&
        this.confirmaNovaSenha !== '' &&
        this.verificadorPoliticas.politicasVisiveisValida
      ) {
        return true
      }
      return false
    }
  },

  methods: {
    ...mapActions(['atualizarSenha', 'auth']),
    ...mapMutations([SET_PERFIS, SET_DADOS_PACIENTE]),
    toggleInfoModal() {
      this.showModal = !this.showModal
    },

    verificaNovaSenhaIgualAtual() {
      return (
        this.senha === this.novaSenha &&
        this.senha !== '' &&
        this.novaSenha !== ''
      )
    },
    senhaNaoConfere() {
      this.mostrarModal(
        this.$t('erro.senhas-nao-conferem.titulo'),
        this.$t('erro.senhas-nao-conferem.subtitulo'),
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    senhaNovaIgualAtual() {
      this.mostrarModal(
        this.$t('erro.senha-igual-atual.titulo'),
        this.$t('erro.senha-igual-atual.subtitulo'),
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },

    async atualizar() {
      if (this.verificarPoliticaSenha()) {
        await this.atualizarSenha({
          username: this.paciente.Prontuario,
          password: this.novaSenha,
          code: this.senha
        })
          .then(() => {
            this.okTexto()
          })
          .catch((erro) => {
            if (erro instanceof NotAuthenticatedError) {
              router.push('/')
            } else {
              this.mostrarModal(
                this.$t('erro.padrao.titulo'),
                erro.detail,
                this.$t('botoes.confirmar'),
                this.toggleInfoModal
              )
            }
          })
      }
    },
    verificarPoliticaSenha() {
      this.verificadorPoliticas.validar(this.novaSenha)

      if (this.novaSenha !== this.confirmaNovaSenha) {
        this.senhaNaoConfere()
        return false
      }

      if (this.verificaNovaSenhaIgualAtual()) {
        this.senhaNovaIgualAtual()
        return false
      }

      if (!this.verificadorPoliticas.senhaValida) {
        var mensagens = this.verificadorPoliticas.mensagensErro().join('\r\n')

        this.mostrarModal(
          this.$t('erro.padrao.titulo'),
          mensagens,
          this.$t('botoes.confirmar'),
          this.toggleInfoModal
        )
      }

      return this.verificadorPoliticas.senhaValida
    },
    logout() {
      authService.logout().then(() => {
        this.SET_PERFIS([])
        this.SET_DADOS_PACIENTE(null)
        this.$router.push('/')
      })
    },
    mostrarModal(titulo, subtitulo, textoBotao, acaoBotao) {
      this.modalInfo = {
        titulo: titulo,
        subtitulo: subtitulo,
        btnTexto: textoBotao,
        acaoBotao: acaoBotao
      }
      this.showModal = !this.showModal
    },
    errorText() {
      this.mostrarModal(
        this.$t('erro.padrao.titulo'),
        this.$t('erro.padrao.subtitulo'),
        this.$t('botoes.confirmar'),
        this.toggleInfoModal
      )
    },
    okTexto() {
      this.mostrarModal(
        this.$t('senha-alteracao.titulo'),
        this.$t('senha-alteracao.subtitulo'),
        this.$t('botoes.sair'),
        this.logout
      )
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/personal-data/Senha.scss"></style>
